<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
        <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>
        
        <v-card class="shadow-none" v-if="!needInit">     
            <v-card-text v-if="myContent">                
                    <xReadContent v-bind:id='20000' v-bind:format='"array"' v-bind:my_elementA="myContent" 
                                  v-bind:runnable='true' v-bind:task_id ='dcontent.task_id' v-bind:user_course_id = "dcontent.user_course_id"/>
                    
                    <p></p>
                    <v-text-field v-model="myAnswer" outlined max-width = "50%" color="styleObject.color">                    
                    </v-text-field>                  
                    <p v-if="feedback" v-bind:style="styleObject">{{feedback}}</p>  
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from '../../axios-auth.js'
import * as logs from '../../assets/log_process.js'
import xReadContent from '../../components/jprcomponents/etype_xread_content.vue'

export default {   
    data() {
        return {
                myContent: null,
                myAnswer : null,
                feedback: null,
                needInit : false,
                styleObject: {
                    color: 'black',
                },
                startTime : null

        }
    },
    computed: 
        mapGetters([
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    ])
    ,    
    props: { 
        dcontent: Object,
        taskIndex: Number,
        activity_type: String
    },
    components: {
        xReadContent
    },
    methods: {
        initData() {
            this.needInit = false  
            this.$store.commit('setFeedback', null) 
            this.myContent = this.dcontent.data.content.content
            this.rating = 0
        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent',false) 

            // send info to server
            let answerList = [ this.myAnswer ]
            const data = {
                task_id : this.dcontent.task_id,
                time_length: Math.floor((new Date() - this.startTime)/1000 + 0.5),
                task_type_id: this.dcontent.task_type_id,
                answer_list : JSON.stringify(answerList),
                activity_type: this.activity_type
            }
            axios.post('/task-evaluate2', data, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.useEvaluation(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })           
        },
        useEvaluation(myData) {
            this.$store.commit('setWaitingForResult',false) // data was delivered
        //    this.$store.commit('setTaskRating',myData.result.rating/20) // for backdrop
            this.$store.commit('setTransferAnswer',{index: this.taskIndex, rating: myData.result.rating})
            this.$store.commit('setUserPerformance',myData.user)
            this.feedback = myData.result.answers[0].feedback
        },           
        showAnswer() {
            this.$store.commit('setShowAnswerEvent', false)
            
            axios.get('/get-my-answer/'+this.dcontent.task_id, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.useAnswer(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })                                   
        },        
        useAnswer(myData) {
            this.myAnswer = myData.answers[0].answer            
            this.$store.commit('setUserPerformance',myData.user)
            this.feedback = myData.answers[0].feedback
        },       
    },
    mounted() {
        this.needInit = true
        this.startTime = new Date()
        logs.write_to_log('open', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, 0, this.$store.getters.getAxiosConfig)
    },
    beforeDestroy() {
        logs.write_to_log('close', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, Math.floor((new Date() - this.startTime)/1000 + 0.5), this.$store.getters.getAxiosConfig)
    }
}
</script>